import { isTouchDevice } from '@trustoo/funcs/isTouchDevice'
import { useEffect, useState } from 'react'

/**
 * Whether the visitor is on a touch device, resolved after mount.
 *
 * The hook form of {@link isTouchDevice} for components that must not read the answer while
 * rendering: it starts at `prediction` so server and first client render agree, then settles on the
 * real value. Call the plain function instead outside render, where there is nothing to hydrate.
 */
export function useIsTouchDevice(prediction: boolean = false): boolean {
    const [isTouch, setIsTouch] = useState(prediction)

    useEffect(() => {
        setIsTouch(isTouchDevice(prediction))
    }, [prediction])

    return isTouch
}
